module.exports = "<svg fill=\"#8b8b8b\" height=\"24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n  <path d=\"M4,4H20V20H4V4M6,8V18H18V8H6Z\" />\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/maximize.svg
// module id = 807
// module chunks = 1